// @ts-nocheck
import React from 'react';
import { I18nextProvider } from 'react-i18next';
import Bugsnag from '@bugsnag/js';
import az from './locales/az.json';
import ru from './locales/ru.json';
import { ContextWrapper } from './context';

document.addEventListener('DOMContentLoaded', async () => {
  const container = document.getElementById('autocatalog-app');
  if (container) {
    try {
      const [{ createRoot }, { AutocatalogMobile, AutocatalogDesktop }, { customizeI18n }] =
        await Promise.all([
          import('react-dom/client'),
          import('./routes'),
          import('../utils/i18n')
        ]);

      const dataset = JSON.parse(JSON.stringify(container.dataset));
      const i18n = customizeI18n({ az, ru });

      createRoot(container).render(
        <I18nextProvider {...{ i18n }}>
          <ContextWrapper {...{ dataset }}>
            {dataset.isMobileSite === 'true' ? <AutocatalogMobile /> : <AutocatalogDesktop />}
          </ContextWrapper>
        </I18nextProvider>
      );
    } catch (error) {
      console.error('Error initializing autocatalog-app:', error);
      Bugsnag.notify(error);
    }
  }
});
